module.exports = __webpack_public_path__ + "img/UniWest.59d58a33.png";